"use client";

import { usePathname } from "next/navigation";

export function MainWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname.startsWith("/admin");
  const isChat = pathname.startsWith("/chat");

  if (isAdmin || isChat) {
    // admin/chat layout이 자체 레이아웃 제공 — 제약 없이 통과
    return <>{children}</>;
  }

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:shadow-lg"
      >
        본문으로 건너뛰기
      </a>
      <main id="main-content" className="mx-auto w-full max-w-4xl flex-1 pb-20 lg:pb-10">
        {children}
      </main>
    </>
  );
}
